export const isLocatedInspectorViolation = (violation, originalText) => {
  const found = violation?.found;
  if (typeof found !== 'string' || found.length === 0) return false;
  return String(originalText || '').includes(found);
};

export const filterLocatedInspectorViolations = (
  violations,
  originalText,
) => (violations || []).filter(
  violation => isLocatedInspectorViolation(violation, originalText),
);

export const sanitizeInspectorResult = (result, originalText) => {
  if (!result) return result;

  const text = originalText
    ?? result.content
    ?? result.input_text
    ?? '';

  // 원문을 저장하지 않던 레거시 기록은 위치를 검증할 근거가 없으므로,
  // 별도의 "저장된 초안 없음" UI에서 기존 위반 정보를 그대로 보존한다.
  if (!text) return {
    ...result,
    basic_violations: [...(result.basic_violations || [])],
    guideline_violations: [...(result.guideline_violations || [])],
  };

  return {
    ...result,
    basic_violations: filterLocatedInspectorViolations(
      result.basic_violations,
      text,
    ),
    guideline_violations: filterLocatedInspectorViolations(
      result.guideline_violations,
      text,
    ),
  };
};

// '참조' 같은 글자 쪽은 붙이지 않는다 ("(참조페이지)" 방지).
export const guidelinePageLabel = (page) => (
  /^[1-9]\d*$/.test(String(page ?? '').trim()) ? ` (${String(page).trim()}페이지)` : ''
);
